export default __webpack_public_path__ + "static/logo_mision-max-curv@big-6067aad2059b4239427e7801e922069a.png";